<template>
  <div class="container">
    <el-button type="text" @click="openSharePop('coach_sport')">教练合作链接</el-button>
    <el-button type="text" @click="openSharePop('mechanism_mp')">招生主理人合作链接</el-button>
    <el-button type="text" @click="openSharePop('nightSchool')">夜校合作链接</el-button>
    <div class="title">开店基金</div>
    <el-form>
      <el-form-item label="投资金额">
        <el-input
          v-model="fundInfo.invest_amount"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="开店基金分成">
        <el-input
          v-model="fundInfo.fund_ratio"
          placeholder="请输入比例"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="updateFund">修改</el-button>
      </el-form-item>
    </el-form>

    <div class="title">投资人</div>
    <el-form :inline="true">
      <el-form-item>
        <el-button type="primary" @click="getList(1)">搜索</el-button>
        <el-button type="success" @click="addActivity">新增</el-button>
      </el-form-item>
    </el-form>
    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
      <template #type="{ row }">
        <div>
          {{ getNameByValue(investTypes, row.type) }}
        </div>
      </template>
      <template #handler="{ row }">
        <div>
          <el-button type="primary" size="small" @click="updateInfo(row)"
            >编辑</el-button
          >
        </div>
      </template>
    </auto-table>

    <div class="title"> {{ getNameByValue(stageType, mechanism.union_way) }}分成</div>

    <el-form>
      
      <el-form-item label="收益上限/月">
        <el-input
          v-model="ceil_divide"
          placeholder="请输入"
        ></el-input>
         <el-button type="success" @click="updateCeil"
            >修改</el-button
          >
      </el-form-item>

      <el-form-item
        :label="ratioTypeMap[r.type]"
        v-for="(r, i) in ratios"
        :key="i"
      >
        <div class="flex" style="width: 240px">
          <el-input
            v-model="r.ratio"
            placeholder="比例，如0.1"
            type="number"
            :max="1"
            :min="0"
          ></el-input>
          <el-button v-if="r.id" type="primary" @click="updateRatioInfo(r)"
            >更新</el-button
          >
          <el-button v-else type="success" @click="addRatioInfo(r)"
            >添加</el-button
          >
        </div>
      </el-form-item>
    </el-form>

    <p>
      分成说明：
    </p>
    <div>
      商场联营-闲置区，按营业额分成
    </div>
    <div>
      商场联营-非闲置区，按利润分成
    </div>
     <div>
      门店改造，按营业额分成
    </div>

    <investRatioEdit @success="getList(1)" ref="iedit" />
    <shareCode ref="code"></shareCode>
  </div>
</template>

<script>

import investRatioEdit from "./investRatioEdit.vue";
import { investTypes } from "../dict.js";
import shareCode from './shareCode.vue';
import { stageType } from "@/views/categoriesManage/components/dict.js";
export default {
  props: {
    mechanism: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components: {
    investRatioEdit,
    shareCode
  },
  data() {
    return {
      stageType,
      ratioTypeMap: {
        divide: "联营分成",
        l_time: "闲时分成",
        h_time: "高峰分成",
      },
      ratios: [],
      investTypes,
      fundInfo: {
        invest_amount: 0,
        fund_ratio: 0,
      },
      ceil_divide:'',
      DataList: [],
      Option: [
        { name: "投资人", value: "name" },
        { name: "投资金额", value: "invest_amount" },
        { name: "投资方式", value: "type", type: "custom" },
        { name: "添加时间", value: "create_time" },
        { name: "操作", value: "handler", type: "custom" },
      ],
      Total: 0,
      id: "",
      entryPath:{
        coach_sport: 'pages/index/shopPartnership/applybind/applybind',
        mechanism_mp:'subpackages/my/applybind/applybind',
        nightSchool:'pages/coachManage/shopPartnership/applybind/applybind',
      }
    };
  },
  watch: {
    mechanism: {
      handler: function (nv) {
        if (nv.id) {
          // this.id = nv.id
          this.ceil_divide = nv.ceil_divide
          this.fundInfo.invest_amount = nv.invest_amount;
          this.fundInfo.fund_ratio = nv.fund_ratio;
           if (nv.operate == "unused" || nv.operate == "third_party") {
            this.ratios = [
              { ratio: "", type: "l_time" },
              { ratio: "", type: "h_time" },
            ];
          }else {
            this.ratios = [{ ratio: "", type: "divide" }];
          } 
          if (nv.is_union) {
            this.getRatio();
          }
        }
      },
      immediate: true,
    },
  },

  mounted() {
    this.id = this.$route.query.mecID;
  },

  methods: {
    openSharePop(v) {

      let p = {
        platform: v,
        page: this.entryPath[v],
        scene: "mid="+ this.mechanism.id,
        title: this.mechanism.mechanism_name
      };
      this.$refs.code.openShare(p);
    },
    getRatio() {
      let data = {
        promoter: this.mechanism.id,
        role: 4,
        types: this.ratios
          .map((t) => {
            return t.type;
          })
          .join(","),
      };
      this.$get("/user/promoterRatio/queryListPage", data).then((res) => {
        // this.ratios = res.data.data;
        let all = [...this.ratios, ...res.data.data];
        let map = {};
        all.forEach((item) => {
          map[item.type] = item;
        });
        this.ratios = Object.values(map);
      });
    },
    updateRatioInfo(row) {
      if (row.ratio < 0 || row.ratio > 1) {
        this.$message("分成比例错误");
        return;
      }
      let data = {
        id: row.id,
        ratio: row.ratio,
      };
      this.$post("/user/promoterRatio/update", data).then((res) => {
        this.getRatio();
        this.$emit("success");
      });
    },
    addRatioInfo(row) {
      if (row.ratio < 0 || row.ratio > 1) {
        this.$message("分成比例错误");
        return;
      }
      let data = {
        promoter: this.id,
        role: 4,
        ratio: row.ratio,
        type: row.type,
      };
      this.$post("/user/promoterRatio/insert", data).then((res) => {
        this.getRatio();
        this.$emit("success");
      });
    },
    updateFund() {
      if (this.fundInfo.fund_ratio < 0 || this.fundInfo.fund_ratio > 1) {
        this.$message("分成比例错误");
        return;
      }
      let data = {
        id: this.id,
        ...this.fundInfo,
      };
      this.$post("/user/mastermechanism/update", data);
    },
    updateCeil(){
      let data = {
        id: this.id,
        ceil_divide: this.ceil_divide,
      };
      this.$post("/user/mastermechanism/update", data);
    },
    addActivity() {
      this.$refs.iedit.open();
    },
    updateInfo(row) {
      this.$refs.iedit.open(row);
    },
    //获取列表
    getList(v) {
      let page = v || 1;
      this.$axios({
        url: "/user/mechanismInvest/queryManagerListPage",
        params: {
          currentPage: page,
          pageSize: 10,
          mechanism_id: this.id,
        },
      }).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total;
      });
    },
  },
};
</script>

<style lang="less" scoped>
</style>